<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <MensagemAlerta class="row-space" v-if="msgAlerta" :mensagem="msgAlerta" />

    <div v-if="!showOSSelect" class="form-edit-page">
        <form @submit.prevent="submitForm">
            <div v-if="osSelecionada" class="row row-space">
                <div class="form-item-codigo">
                    <label class="label-caption">OS</label>
                    <div class="field-label field-label-end">{{ osSelecionada.cdos }}</div>
                </div>

                <div class="form-item">
                    <label class="label-caption">Nome</label>
                    <div class="field-label">{{ osSelecionada.nmpessoa }}</div>
                </div>

                <div class="form-item">
                    <label class="label-caption">Serviço</label>
                    <div class="field-label">{{ osSelecionada.nmservico }}</div>
                </div>
            </div>
            
            
            <div class="row row-space">
                <EquipamentoSelect :flagTipo="1" :idGrupo="idGrupo" class="form-item"
                    v-model:idSelecionado="idEquipamento"
                    @update:objSelecionado="atualizarEquipamento" required />
                    
                <OperadorSelect class="form-item" v-model:idSelecionado="idOperador" required />
            </div>


            <div class="row-start">
                <div class="form-item-data">
                    <label class="label-caption">Contratação</label>
                    <div class="field-label field-label-center">{{ Funcoes.formatDateFromJson(osSelecionada.dtinclusao) }}</div>
                </div>

                <div v-if="osSelecionada.cdmedicao == 2" class="form-item-codigo">
                    <label class="label-caption">Entregas</label>
                    <div class="field-label field-label-center">{{ Funcoes.formatInteger(osSelecionada.mncontratados/60) }}</div>
                </div>
                <div v-else class="form-item-codigo">
                    <label class="label-caption">Horas</label>
                    <div class="field-label field-label-center">{{ osSelecionada.hrcontratadas }}</div>
                </div>

                <div class="form-item-data">
                    <label class="label-caption">Data execução</label>
                    <input type="date" v-model="edDtExecucao" required />
                </div>

                <div class="form-item-hora">
                    <label class="label-caption">Horário</label>
                    <input type="text" class="input-center" v-time-mask v-model="edHrInicio" required />
                </div>

                <div class="form-item-data">
                    <label class="label-caption">Horímetro Inicial</label>
                    <input v-model="edVlInicial" v-decimal-mask type="text" class="input-right" @input="calcularTempo" required />
                </div>

                <div class="form-item-data">
                    <label class="label-caption">Horímetro Final</label>
                    <input v-model="edVlFinal" v-decimal-mask type="text" class="input-right" @input="calcularTempo" required />
                </div>    
                
                <div v-if="osSelecionada.cdmedicao==2" class="form-item-char15">
                    <label class="label-caption">Entregas Efetivadas</label>
                    <input v-model="edTtEntregas" v-number class="input-right" />
                </div>
                <div v-else class="form-item-data">
                    <label class="label-caption">Hr trabalhadas</label>
                    <div class="field-label field-label-center">{{ hrTrabalhadas }}</div>
                </div>
            </div>

            <div class="row-end margin-top10">
                <button class="btn-confirm" type="submit">Salvar</button>
                <button class="btn-cancel" type="cancel" @click="openOSSelect">Cancelar</button>
            </div>
        </form>
    </div>

    <div v-if="showOSSelect">
        <OsPesquisaPage
            :idSituacao="2"
            @cancel="cancelForm"
            @select="selecionarOS" />
    </div>
</template>

<script setup>
import { ref } from 'vue';
import { Funcoes } from '@/funcoes/utils';
import { genericPost } from '@/funcoes/api';
import { globalStore } from '@/globals';
import EquipamentoSelect from '@/selects/EquipamentoSelect.vue';
import MensagemAlerta from '@/components/MensagemAlerta.vue';
import OperadorSelect from '@/selects/OperadorSelect.vue';
import OsPesquisaPage from './OsPesquisaPage.vue';

const emit = defineEmits(['close', 'salvo']);
const hrTrabalhadas = ref(null)
const idGrupo = ref(null);
const isLoading = ref(false);
const msgAlerta = ref(false);
const showOSSelect = ref(true);

const edDtExecucao = ref(new Date().toISOString().split('T')[0]);
const edHrInicio = ref("08:00");
const edTtEntregas = ref(0);
const edVlInicial = ref(0);
const edVlFinal = ref(null);
const idEquipamento = ref(null);
const idOperador = ref(null);

// OBJETOS
const equipamentoSelecionado = ref(null);
const osSelecionada = ref(null);

const atualizarEquipamento = (novoEquipamento) => {
    equipamentoSelecionado.value = novoEquipamento;
    if (equipamentoSelecionado.value.idoperador){idOperador.value = equipamentoSelecionado.value.idoperador;}
};

const calcularTempo = () =>{
    const diferenca = Funcoes.decimalFromString(edVlFinal.value) - Funcoes.decimalFromString(edVlInicial.value);
    if (diferenca>0){
        const horas = Math.floor(diferenca);
        const minutos = Math.round((diferenca - horas) * 60);
        hrTrabalhadas.value = `${String(horas).padStart(2, "0")}:${String(minutos).padStart(2, "0")}`;
    }else{hrTrabalhadas.value='00:00'}
}

const cancelForm = () => {emit('close');};

const openOSSelect = () => {
    showOSSelect.value=true;
}

const selecionarOS = (os) => {
    showOSSelect.value      = false;
    osSelecionada.value     = os;
    idGrupo.value           = os.idequipamento_grupo;
};

const submitForm = async () => {
    try{
        msgAlerta.value=null;
        if (Funcoes.decimalFromString(edVlInicial.value) >= Funcoes.decimalFromString(edVlFinal.value)){
            throw new Error('Valor final deve ser maior que valor inicial');
        }
        isLoading.value=true;
        const ret = await genericPost('/main/exec_requisicao', {
            nmrequisicao: 'os_encerrar_horimetro',
            idmunicipio: globalStore.idmunicipio,
            idos: osSelecionada.value.id,
            idequipamento: idEquipamento.value,
            idoperador: idOperador.value,
            datainicial: edDtExecucao.value,
            horainicial: edHrInicio.value,
            double1: Funcoes.decimalFromString(edVlInicial.value),
            double2: Funcoes.decimalFromString(edVlFinal.value),
            intparam1: Funcoes.integerFromString(edTtEntregas.value),
            strparam1: 'N',
            idlogin: globalStore.idlogin,
            idusuario: globalStore.idusuario});
        if (ret.bolok === 1){
            emit('save');
            showOSSelect.value  = true;
            edVlInicial.value   = null;
            edVlFinal.value     = null;
        }else{
            msgAlerta.value = `ATENÇÃO: ${ret.erro}`;
        }
    }catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    }finally{isLoading.value=false;}
}
</script>
